var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.352,
    height: 24.091,
    viewBox: "0 0 18.352 24.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_4_",
    "data-name": "document (4)",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M78.541,5,74,.708A2.578,2.578,0,0,0,72.226,0H63.588A2.591,2.591,0,0,0,61,2.588V21.5a2.591,2.591,0,0,0,2.588,2.588H76.763A2.591,2.591,0,0,0,79.351,21.5V6.88A2.6,2.6,0,0,0,78.541,5Zm-1.371.646H73.657a.236.236,0,0,1-.235-.235V2.1Zm-.408,17.033H63.588A1.178,1.178,0,0,1,62.412,21.5V2.588a1.178,1.178,0,0,1,1.176-1.176H72.01v4a1.649,1.649,0,0,0,1.647,1.647h4.282V21.5A1.178,1.178,0,0,1,76.763,22.679Z",
    fill: "#707374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M139.057,200H128.706a.706.706,0,1,0,0,1.412h10.352a.706.706,0,0,0,0-1.412Z",
    transform: "translate(-63.847 -190.589)",
    fill: "#707374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M139.057,280H128.706a.706.706,0,1,0,0,1.412h10.352a.706.706,0,0,0,0-1.412Z",
    transform: "translate(-63.847 -266.825)",
    fill: "#707374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M132.127,360h-3.422a.706.706,0,1,0,0,1.412h3.422a.706.706,0,0,0,0-1.412Z",
    transform: "translate(-63.847 -343.061)",
    fill: "#707374"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBlack);
export default __webpack_public_path__ + "static/media/file-icon-black.c63712f297636570f7c844e7e96a97e4.svg";
export { ForwardRef as ReactComponent };